"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPassengerItem = exports.SearchPassengerItemGroup = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const dateTime_1 = require("../../../../../utils/dateTime");
const fullName_1 = require("../../../../../utils/fullName");
require("./index.scss");
const SearchPassengerItemGroup = (props) => {
    const { className, label, children } = props;
    const ownClassName = 'search-passenger-item-group';
    const classNames = (0, classnames_1.default)(ownClassName, className !== null && className !== void 0 ? className : '');
    if (!children) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${ownClassName}__label` }, label),
        react_1.default.createElement("div", { className: `${ownClassName}__items` }, children)));
};
exports.SearchPassengerItemGroup = SearchPassengerItemGroup;
const SearchPassengerItem = (props) => {
    const { className, firstName, lastName, birthday, onClick, isSelected, } = props;
    const ownClassName = 'search-passenger-item';
    const classNames = (0, classnames_1.default)(ownClassName, { [`${ownClassName}--selected`]: !!isSelected }, className !== null && className !== void 0 ? className : '');
    const onClickHandler = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const fullName = (0, fullName_1.createFullName)(firstName, lastName);
    return (react_1.default.createElement("div", { className: classNames, onClick: onClickHandler },
        react_1.default.createElement("div", { className: `${ownClassName}__name` }, fullName),
        react_1.default.createElement("div", { className: `${ownClassName}__birthday` }, (0, dateTime_1.toInputDateString)(birthday))));
};
exports.SearchPassengerItem = SearchPassengerItem;
//# sourceMappingURL=index.js.map